import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { WebcamImage, WebcamModule } from 'ngx-webcam';
import { Observable, Subject } from 'rxjs';
import { MaterialModule } from 'src/app/material.module';

@Component({
  selector: 'app-webcam-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MaterialModule,
    WebcamModule,
    TablerIconsModule,
    TranslateModule
  ],
  templateUrl: './webcam-dialog.component.html',
  styleUrl: './webcam-dialog.component.scss'
})
export class WebcamDialogComponent implements OnInit {

  stream: any = null;
  status: any = null;
  trigger: Subject<void> = new Subject();
  previewImage: string = '';
  btnLabel: string = 'Capture image';
  ImageAllProperty:any;

  constructor(
    private dialogRef: MatDialogRef<WebcamDialogComponent>,
  ){}

  ngOnInit(): void {
    this.checkPermissions();
  }
  get $trigger(): Observable<void> {
    return this.trigger.asObservable();
  }

  snapshot(event: WebcamImage) {
    this.previewImage = event.imageAsDataUrl;
    this.ImageAllProperty=event;
    this.btnLabel = 'Re-capture image'
  }

  checkPermissions() {
    navigator.mediaDevices.getUserMedia({
      video: {
        width: 500,
        height: 500
      }
    }).then((res) => {
      this.stream = res;
      this.status = 'My camera is accessing';
      this.btnLabel = 'Capture image';
    }).catch(err => {
      if (err?.message === 'Permission denied') {
        alert('Permission denied please try again by approving the access');
        this.dialogRef.close();
      } else {
        alert('You may not having camera system, Please try again ...');
        this.dialogRef.close();
      }
    })
  }

  captureImage() {
    this.trigger.next();
  }

  proceed() {

    this.dialogRef.close(this.ImageAllProperty);
  }
}
